import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InputComponent } from '../input/input.component';

/**
 * Wrapper for a group of radio buttons.
 *
 * Should not be used without radio buttons.
 *
 * @example
 * <cfe-radio-wrapper
 *                [control]="formControl"
 *                [groupHeading]="'Heading for the radio group'"
 *                [groupSubHeading]="'Radio Group - Subtitle'"
 *                [notMarkAsRequired]="false">
 * </cfe-radio-wrapper>
 */

@Component({
	selector: 'cfe-input-radio-wrapper',
	templateUrl: './input-radio-wrapper.component.html',
	styleUrls: ['./input-radio-wrapper.component.scss']
})
export class InputRadioWrapperComponent extends InputComponent {
	constructor() {
		super();
	}
	/**
	 * Angular form control
	 *
	 * Should be same as for the individual radio buttons
	 */
	@Input() control: FormControl;

	/**
	 * Heading shown for the radio group wrapped by this component
	 */
	@Input() groupHeading: string;
	/**
	 * Heading shown for the radio group wrapped by this component
	 */
	@Input() groupSubHeading: string;

	/**
	 * Set true if you don't want to display the required marker (*)
	 */
	@Input() markAsRequired = false;
}
